/* GENERATED by apps/main/ops/run-fr/gen_registry.mjs — DO NOT EDIT BY HAND.
 * The federal court rules this corpus actually holds, compiled small enough to ship to a browser.
 * Regenerate after any rule ingest; the `asOf` dates below are what a surface may claim.
 */
export default {
 "_doc": "RUN FR — generated from court_rules. DO NOT EDIT BY HAND; regenerate with node apps/main/ops/run-fr/gen_registry.mjs. Existence answers are only as current as as_of.",
 "generatedAt": "2026-09-02T02:52:41.732Z",
 "sets": {
  "frap": {
   "prefix": "Fed. R. App. P.",
   "name": "Federal Rules of Appellate Procedure",
   "asOf": "Wed Dec 03",
   "release": "119-100",
   "rules": 55,
   "live": 52
  },
  "frbp": {
   "prefix": "Fed. R. Bankr. P.",
   "name": "Federal Rules of Bankruptcy Procedure",
   "asOf": "Wed Jan 28",
   "release": "119-100",
   "rules": 229,
   "live": 229
  },
  "frcp": {
   "prefix": "Fed. R. Civ. P.",
   "name": "Federal Rules of Civil Procedure",
   "asOf": "Wed Dec 03",
   "release": "119-100",
   "rules": 99,
   "live": 94
  },
  "frcp-supp-adm": {
   "prefix": "Fed. R. Civ. P. Supp. R.",
   "name": "Supplemental Rules for Admiralty or Maritime Claims and Asset Forfeiture Actions",
   "asOf": "Wed Dec 03",
   "release": "119-100",
   "rules": 7,
   "live": 7
  },
  "frcp-supp-ss": {
   "prefix": "Supp. R. Soc. Sec.",
   "name": "Supplemental Rules for Social Security Actions Under 42 U.S.C. § 405(g)",
   "asOf": "Wed Dec 03",
   "release": "119-100",
   "rules": 8,
   "live": 8
  },
  "frcrp": {
   "prefix": "Fed. R. Crim. P.",
   "name": "Federal Rules of Criminal Procedure",
   "asOf": "Wed Jan 28",
   "release": "119-100",
   "rules": 77,
   "live": 73
  },
  "fre": {
   "prefix": "Fed. R. Evid.",
   "name": "Federal Rules of Evidence",
   "asOf": "Wed Dec 03",
   "release": "119-100",
   "rules": 69,
   "live": 69
  }
 },
 "rules": {
  "frap": {
   "1": "abc",
   "2": "ab",
   "3": "abcde",
   "4": "abcd",
   "5": "abcd",
   "6": "abc",
   "7": "",
   "8": "abc",
   "9": "abc",
   "10": "abcde",
   "11": "abcdefg",
   "12": "abc",
   "13": "ab",
   "14": "",
   "15": "abcde",
   "16": "ab",
   "17": "ab",
   "18": "ab",
   "19": "",
   "20": "",
   "21": "abcd",
   "22": "ab",
   "23": "abcd",
   "24": "abc",
   "25": "abcde",
   "26": "abc",
   "27": "abcde",
   "28": "abcdefghij",
   "29": "ab",
   "30": "abcdef",
   "31": "abc",
   "32": "abcdefg",
   "33": "",
   "34": "abcdefg",
   "35": "",
   "36": "ab",
   "37": "ab",
   "38": "",
   "39": "abcdef",
   "40": "abcdefg",
   "41": "abcd",
   "42": "abcd",
   "43": "abc",
   "44": "ab",
   "45": "abcd",
   "46": "abc",
   "47": "ab",
   "48": "ab",
   "12.1": "ab",
   "15.1": "",
   "26.1": "abcde",
   "28.1": "abcdef",
   "3.1": "",
   "32.1": "ab",
   "5.1": ""
  },
  "frbp": {
   "1001": "abcd",
   "1002": "ab",
   "1003": "abc",
   "1004": "",
   "1005": "ab",
   "1006": "abc",
   "1007": "abcdefghijklm",
   "1008": "",
   "1009": "abcd",
   "1010": "ab",
   "1011": "abcdef",
   "1012": "abc",
   "1013": "ab",
   "1014": "ab",
   "1015": "abc",
   "1016": "ab",
   "1017": "abcdef",
   "1018": "abc",
   "1019": "abcdef",
   "1020": "abc",
   "1021": "ab",
   "2001": "abcd",
   "2002": "abcdefghijklmnopq",
   "2003": "abcdefg",
   "2004": "abcde",
   "2005": "ab",
   "2006": "abcdef",
   "2007": "abc",
   "2008": "ab",
   "2009": "abcde",
   "2010": "ab",
   "2011": "ab",
   "2012": "ab",
   "2013": "ab",
   "2014": "ab",
   "2015": "abcdef",
   "2016": "abc",
   "2017": "ab",
   "2018": "abcde",
   "2019": "abcde",
   "2020": "",
   "3001": "abcdefg",
   "3002": "abc",
   "3003": "abcd",
   "3004": "ab",
   "3005": "ab",
   "3006": "abc",
   "3007": "abcdef",
   "3008": "",
   "3009": "ab",
   "3010": "ab",
   "3011": "ab",
   "3012": "abc",
   "3013": "",
   "3014": "ab",
   "3015": "abcdefgh",
   "3016": "abcd",
   "3017": "abcdef",
   "3018": "abcd",
   "3019": "abc",
   "3020": "abcde",
   "3021": "ab",
   "3022": "",
   "4001": "abcd",
   "4002": "ab",
   "4003": "abcd",
   "4004": "abcdefg",
   "4005": "",
   "4006": "abcd",
   "4007": "abcde",
   "4008": "ab",
   "5001": "abc",
   "5002": "ab",
   "5003": "abcdef",
   "5004": "ab",
   "5005": "abc",
   "5006": "",
   "5007": "abc",
   "5008": "ab",
   "5009": "abcd",
   "5010": "",
   "5011": "abcd",
   "5012": "",
   "6001": "",
   "6002": "ab",
   "6003": "ab",
   "6004": "abcdefgh",
   "6005": "",
   "6006": "abcdefg",
   "6007": "ab",
   "6008": "",
   "6009": "ab",
   "6010": "",
   "6011": "abcd",
   "7001": "abcdefghij",
   "7002": "",
   "7003": "",
   "7004": "abcdefghi",
   "7005": "",
   "7007": "",
   "7008": "",
   "7009": "",
   "7010": "",
   "7012": "ab",
   "7013": "ab",
   "7014": "",
   "7015": "",
   "7016": "ab",
   "7017": "",
   "7018": "",
   "7019": "ab",
   "7020": "",
   "7021": "",
   "7022": "",
   "7023": "",
   "7024": "",
   "7025": "",
   "7026": "",
   "7027": "",
   "7028": "",
   "7029": "",
   "7030": "",
   "7031": "",
   "7032": "",
   "7033": "",
   "7034": "",
   "7035": "",
   "7036": "",
   "7037": "",
   "7040": "",
   "7041": "ab",
   "7042": "",
   "7052": "",
   "7054": "ab",
   "7055": "",
   "7056": "",
   "7058": "",
   "7062": "",
   "7064": "",
   "7065": "",
   "7067": "",
   "7068": "",
   "7069": "",
   "7070": "",
   "7071": "",
   "7087": "",
   "8001": "abc",
   "8002": "abcd",
   "8003": "abcd",
   "8004": "abcde",
   "8005": "abcd",
   "8006": "abcdefg",
   "8007": "abcde",
   "8008": "abc",
   "8009": "abcdefg",
   "8010": "abc",
   "8011": "abcde",
   "8012": "abc",
   "8013": "abcdefg",
   "8014": "abcdef",
   "8015": "abcdefgh",
   "8016": "abcde",
   "8017": "ab",
   "8018": "abcde",
   "8019": "abcdefgh",
   "8020": "ab",
   "8021": "abcd",
   "8022": "ab",
   "8023": "abcd",
   "8024": "abc",
   "8025": "abcd",
   "8026": "ab",
   "8027": "ab",
   "8028": "",
   "9001": "ab",
   "9002": "abcde",
   "9003": "ab",
   "9004": "ab",
   "9005": "",
   "9006": "abcdefg",
   "9007": "ab",
   "9008": "",
   "9009": "abc",
   "9010": "abc",
   "9011": "abcdef",
   "9012": "ab",
   "9013": "ab",
   "9014": "abcde",
   "9015": "abc",
   "9016": "",
   "9017": "",
   "9018": "ab",
   "9019": "abc",
   "9020": "",
   "9021": "",
   "9022": "ab",
   "9023": "abc",
   "9024": "ab",
   "9025": "",
   "9026": "",
   "9027": "abcdefghi",
   "9028": "",
   "9029": "abc",
   "9030": "",
   "9031": "",
   "9032": "",
   "9033": "abc",
   "9034": "abcdefghijk",
   "9035": "",
   "9036": "abcde",
   "9037": "abcdefgh",
   "9038": "abc",
   "1004.1": "ab",
   "1004.2": "ab",
   "2007.1": "abc",
   "2007.2": "abcde",
   "2015.1": "ab",
   "2015.2": "",
   "2015.3": "abcdef",
   "3002.1": "abcdefgh",
   "3015.1": "abcde",
   "3017.1": "abc",
   "3017.2": "abcd",
   "7007.1": "ab",
   "7023.1": "",
   "7023.2": "",
   "8018.1": "",
   "8023.1": "abc",
   "9005.1": ""
  },
  "frcp": {
   "1": "",
   "2": "",
   "3": "",
   "4": "abcdefghijklmn",
   "5": "abcd",
   "6": "abcd",
   "7": "ab",
   "8": "abcde",
   "9": "abcdefgh",
   "10": "abc",
   "11": "abcd",
   "12": "abcdefghi",
   "13": "abcdefghi",
   "14": "abc",
   "15": "abcd",
   "16": "abcdef",
   "17": "abcd",
   "18": "ab",
   "19": "abcd",
   "20": "ab",
   "21": "",
   "22": "ab",
   "23": "abcdefgh",
   "24": "abc",
   "25": "abcd",
   "26": "abcdefg",
   "27": "abc",
   "28": "abc",
   "29": "ab",
   "30": "abcdefg",
   "31": "abc",
   "32": "abcd",
   "33": "abcd",
   "34": "abc",
   "35": "ab",
   "36": "ab",
   "37": "abcdef",
   "38": "abcde",
   "39": "abc",
   "40": "",
   "41": "abcd",
   "42": "ab",
   "43": "abcd",
   "44": "abc",
   "45": "abcdefg",
   "46": "",
   "47": "abc",
   "48": "abc",
   "49": "ab",
   "50": "abcde",
   "51": "abcd",
   "52": "abc",
   "53": "abcdefgh",
   "54": "abcd",
   "55": "abcd",
   "56": "abcdefgh",
   "57": "",
   "58": "abcde",
   "59": "abcde",
   "60": "abcde",
   "61": "",
   "62": "abcdefgh",
   "63": "",
   "64": "ab",
   "65": "abcdef",
   "66": "",
   "67": "ab",
   "68": "abcd",
   "69": "ab",
   "70": "abcde",
   "71": "",
   "72": "ab",
   "73": "abc",
   "74": "",
   "75": "",
   "76": "",
   "77": "abcd",
   "78": "ab",
   "79": "abcd",
   "80": "",
   "81": "abcd",
   "82": "",
   "83": "ab",
   "84": "",
   "85": "",
   "86": "ab",
   "87": "abc",
   "16.1": "abc",
   "23.1": "abc",
   "23.2": "",
   "4.1": "ab",
   "44.1": "",
   "5.1": "abcd",
   "5.2": "abcdefgh",
   "62.1": "abc",
   "65.1": "",
   "7.1": "ab",
   "71.1": "abcdefghijkl",
   "71A": ""
  },
  "frcp-supp-adm": {
   "A": "12",
   "B": "123",
   "C": "123456b",
   "D": "",
   "E": "123456789b",
   "F": "123456789",
   "G": ""
  },
  "frcp-supp-ss": {
   "1": "ab",
   "2": "ab",
   "3": "",
   "4": "abcd",
   "5": "",
   "6": "",
   "7": "",
   "8": ""
  },
  "frcrp": {
   "1": "abc",
   "2": "",
   "3": "",
   "4": "abcd",
   "5": "abcdefg",
   "6": "abcdefghi",
   "7": "abcdef",
   "8": "ab",
   "9": "abcd",
   "10": "abc",
   "11": "abcdefgh",
   "12": "abcdefgh",
   "13": "",
   "14": "ab",
   "15": "abcdefgh",
   "16": "abcd",
   "17": "abcdefgh",
   "18": "",
   "19": "",
   "20": "abcd",
   "21": "abcd",
   "22": "",
   "23": "abc",
   "24": "abc",
   "25": "ab",
   "26": "",
   "27": "",
   "28": "",
   "29": "abcd",
   "30": "abcd",
   "31": "abcd",
   "32": "abcdefghijk",
   "33": "ab",
   "34": "ab",
   "35": "abc",
   "36": "",
   "37": "abc",
   "38": "abcdefg",
   "39": "",
   "40": "abcd",
   "41": "abcdefghi",
   "42": "ab",
   "43": "abc",
   "44": "abc",
   "45": "abc",
   "46": "abcdefghij",
   "47": "abcd",
   "48": "ab",
   "49": "abcd",
   "50": "",
   "51": "ab",
   "52": "ab",
   "53": "",
   "54": "",
   "55": "",
   "56": "abc",
   "57": "abc",
   "58": "abcdefg",
   "59": "ab",
   "60": "ab",
   "61": "",
   "62": "abcde",
   "12.1": "abcdef",
   "12.2": "abcde",
   "12.3": "abcde",
   "12.4": "ab",
   "16.1": "ab",
   "17.1": "",
   "26.1": "",
   "26.2": "abcdefg",
   "26.3": "",
   "29.1": "abc",
   "32.1": "abcde",
   "32.2": "abcde",
   "4.1": "abc",
   "49.1": "abcdefgh",
   "5.1": "abcdefgh"
  },
  "fre": {
   "101": "ab",
   "102": "",
   "103": "abcde",
   "104": "abcde",
   "105": "",
   "106": "",
   "107": "abcd",
   "201": "abcdef",
   "301": "",
   "302": "",
   "401": "ab",
   "402": "",
   "403": "",
   "404": "ab",
   "405": "ab",
   "406": "",
   "407": "",
   "408": "ab",
   "409": "",
   "410": "ab",
   "411": "",
   "412": "abcd",
   "413": "abcd",
   "414": "abcd",
   "415": "abc",
   "501": "",
   "502": "abcdefg",
   "601": "",
   "602": "",
   "603": "",
   "604": "",
   "605": "",
   "606": "ab",
   "607": "",
   "608": "ab",
   "609": "abcde",
   "610": "",
   "611": "abc",
   "612": "abc",
   "613": "ab",
   "614": "abc",
   "615": "ab",
   "701": "abc",
   "702": "abcd",
   "703": "",
   "704": "ab",
   "705": "",
   "706": "abcde",
   "801": "abcd",
   "802": "",
   "803": "110111213141516171819220212223243456789",
   "804": "ab",
   "805": "",
   "806": "",
   "807": "ab",
   "901": "ab",
   "902": "1101112131423456789",
   "903": "",
   "1001": "abcde",
   "1002": "",
   "1003": "",
   "1004": "abcd",
   "1005": "",
   "1006": "abc",
   "1007": "",
   "1008": "abc",
   "1101": "abcde",
   "1102": "",
   "1103": ""
  }
 },
 "notCurrent": {
  "Fed. R. App. P. 3.1": "abrogated",
  "Fed. R. App. P. 35": "transferred",
  "Fed. R. App. P. 5.1": "abrogated",
  "Fed. R. Civ. P. 71A": "renumbered",
  "Fed. R. Civ. P. 74": "abrogated",
  "Fed. R. Civ. P. 75": "abrogated",
  "Fed. R. Civ. P. 76": "abrogated",
  "Fed. R. Civ. P. 84": "abrogated",
  "Fed. R. Crim. P. 19": "reserved",
  "Fed. R. Crim. P. 22": "transferred",
  "Fed. R. Crim. P. 39": "reserved",
  "Fed. R. Crim. P. 54": "transferred"
 }
};
